import type { NextPageContext } from "next";

/**
 * Create an authenticated server side request configuration by proxying any
 * cookie authentication for the given incoming request. This should only ever
 * be called from the server side.
 * param {import("next").NextPageContext} nextContext
 *
 * return {{headers: Object}} a request configuration object, as specified in
 * the Request interface of the fetch API:
 * https://developer.mozilla.org/en-US/docs/Web/API/Request/Request
 */
const authenticatedServerSideRequestConfig = ({
  req: incomingRequest,
}: NextPageContext): Record<string, unknown> => {
  if (!incomingRequest?.headers?.cookie) return {};

  return {
    headers: {
      Cookie: incomingRequest.headers.cookie,
    },
  };
};

export default authenticatedServerSideRequestConfig;
